<template lang="pug">
  .box
    .weBox
      .banner
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide>
            a(href="https://appgallery.huawei.com/#/app/C102888969?locale=zh_CN&source=appshare&subsource=C102888969&shareTo=weixin&shareFrom=appmarket" target="_blank")
              img(src="https://file.s5yun.com/resources/appico/16155115363871836_轮播图速云APP.jpg" alt="")
          </swiper-slide>
          <swiper-slide>
            img(src="../assets/img/home/banner2.jpg" alt="" @click="goCase")
          </swiper-slide>
          <swiper-slide>
            img(src="../assets/img/home/banner3.jpg" alt="" @click="goWe")
          </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      .weHeader
        h3 关于<span>我们</span>
        p ABOUT US
        em
      .weBody
        .bodyLeft
          h3 创新科技 引领未来 速云·数据办公化首选
          .card
            p 速云软件专注于企业管理软件的研发、销售和服务，为企业提供信息化建设与软件解决方案。公司将软件的行业化作为产品的定位方向，目前已拥有自主研发品牌“速云”，和数十项国家级专利证书。自成立以来，速云软件持续为初创型中小企业、大型集团公司、政府机关部门、学校教育机构等各类组织提供集信息门户定制、公文流转、财务审批、培训管理等一体化解决方案。“用心服务，共创价值”，未来，速云软件愿助力更多的组织实现实现数字化变革！
            <i class="iconfont iconbianjiao"></i>
            <i class="iconfont iconbianjiao-copy"></i>
          button(@click="goWe") 了解详情
        .bodyRight
          img(src="https://file.s5yun.com/resources/appico/16155115216206147_公司.png" alt="")
          //.broadcast
            <i class="iconfont iconbofanganniu"></i>
            p 观看视频
    .productBox
      .productHeader
        h3 业务<span>产品</span>
        p BUSINESS
        em
      .productBody
        .goodsBox
          .goodsTitle
            ul
              li(:class="[flag==1? 'green':'']" @click="flag=1")
                <i class="iconfont iconpingtai"></i>
                p 速云平台
              li(:class="[flag==2? 'green':'']" @click="flag=2")
                <i class="iconfont iconiconzhengli_shitang"></i>
                p 速云食堂
              li(:class="[flag==3? 'green':'']" @click="flag=3")
                <i class="iconfont iconxueyuan"></i>
                p 速云学院
              li(:class="[flag==4? 'green':'']" @click="flag=4")
                <i class="iconfont icongerenmenhu"></i>
                p 速云门户
              li(:class="[flag==5? 'green':'']" @click="flag=5")
                <i class="iconfont icongongwen"></i>
                p 速云公文
              li(:class="[flag==6? 'green':'']" @click="flag=6")
                <i class="iconfont icondangjian"></i>
                p 速云党建
          .goodsBody
            .oneBox(v-if="flag==1")
              .oneTitle 速云平台
              p 速云平台，面向管理者和业务人员低代码应用搭建平台，提供代码扩展及应用集成能力，帮助企业轻松构建专属的业务应用。
              .btns
                ul
                  li(v-for="item,index in btns" :key="index") {{item}}
              a(href="javascript:;" @click="goProduct(1)") 了解更多>
            .oneBox(v-if="flag==2")
              .oneTitle 速云食堂
              p 速云食堂，基于政府机关、企事业单位食堂管理模式，多端互通，为食堂管理者提供食堂优化运营的数据支撑，提升就餐者就餐体验和食堂服务水平。
              .btns
                ul
                  li(v-for="item,index in btns1" :key="index") {{item}}
              a(href="javascript:;" @click="goProduct(2)") 了解更多>
            .oneBox(v-if="flag==3")
              .oneTitle 速云学院
              p 速云学院，多元化满足组织的人才发展需求，提升组织竞争实力，帮助众多用户，快速完成线下和线上的学习需求深耕并专注在线教育，助力政企开启全新培训新模式。
              .btns
                ul
                  li(v-for="item,index in btns2" :key="index") {{item}}
              a(href="javascript:;" @click="goProduct(3)") 了解更多>
            .oneBox(v-if="flag==4")
              .oneTitle 速云门户
              p 速云门户，将不同的应用在同一平台上得到统一管理 ，打造千人千面的专属门户 ，实现组织结构各类资源的有效整合和精准推送。
              .btns
                ul
                  li(v-for="item,index in btns3" :key="index") {{item}}
              a(href="javascript:;" @click="goProduct(4)") 了解更多>
            .oneBox(v-if="flag==5")
              .oneTitle 速云公文
              p 速云公文，解决公文处理的连续性和全面性，实现对公文处理和管理的全过程，推动公文管理“快、简、省、高“，大幅度地提高公文管理工作效率。
              .btns
                ul
                  li(v-for="item,index in btns4" :key="index") {{item}}
              a(href="javascript:;" @click="goProduct(5)") 了解更多>
            .oneBox(v-if="flag==6")
              .oneTitle 速云党建
              p 速云党建，通过对党员管理，初步构建“党务管理智能化、信息管理维护精准化、党员教育管理个性化”的智慧工作新模式。
              .btns
                ul
                  li(v-for="item,index in btns5" :key="index") {{item}}
              a(href="javascript:;" @click="goProduct(6)") 了解更多>
    .solutionBox
      .solutionHeader
        h3 解决<span>方案</span>
        p SOLUTION
        em
      .solutionBody
        ul
          li(@click="goSlution")
            .one
              h3 核心解决方案
              p CORE SOLUTION
              em
              p 提供企业核心办公解决方案
              <i class="iconfont iconicon-right"></i>
          li
            .one
              h3 企业办公解决方案
              p  OFFICE SOLUTION
              em
              p 提供企业核心办公解决方案
              <i class="iconfont iconicon-right"></i>
          li
            .one
              h3 数据解决方案
              p CORE SOLUTION
              em
              p 提供企业核心办公解决方案
              <i class="iconfont iconicon-right"></i>
    .newsBox
      .newsHeader
        h3 新闻<span>动态</span>
        p NEWS
        em
      .newsBody
        //.btnBox
          button(:class="[flag1==1? 'blue':'']" @click="change") 公司新闻
          button(:class="[flag1==2? 'blue':'']" @click="change") 行业资讯
        ul
          li(@click="goNews(1)")
            img(src="https://file.s5yun.com/resources/appico/16161423150407892_dingdingm2.png")
            p 签约兰州市税务局——速云软件&钉钉数字一体化解决方案，赋能...
            .date
              span 2020-04-16
              span >
          li(@click="goNews(2)")
            img(src="https://file.s5yun.com/resources/appico/16152813755941755_new8.png")
            p 2021“陇政钉”新功能培训会
            .date
              span 2021-02-03
              span >
          li(@click="goNews(3)")
            img(src="https://file.s5yun.com/resources/appico/16152813713034423_new7.png")
            p 速云软件成功签约第五届兰州科技成果博览会科技合作与成果...
            .date
              span 2020-09-20
              span >
    .cooperationBox
      .cooperationHeader
        h3 合作<span>伙伴</span>
        p PARTNERS
        em
      .cooperationBody
        .tags
          ul
            li
              img(src="../assets/img/ding.png" alt="" style="margin: 25px 0 0 42px;")
            li
              img(src="../assets/img/baidu.png" alt="" style="margin: 25px 0 0 45px;")
            li
              img(src="../assets/img/liantong.png" alt="" style="width:148px;margin: 26px 0 0 14px;")
            li
              img(src="../assets/img/tian.png" alt="" style="width:168px;margin: 28px 5px 0;")
            li
              img(src="../assets/img/jiaodian.png" alt="" style="width:160px;margin: 26px 10px 0;")
</template>

<script>
export default {
  data () {
    return {
      flag: 1,
      btns: ['门户管理', '移动应用', '新闻管理', '流程管理', '知识仓库', '公文管理', '资产管理', '项目管理', '任务管理', '数据报表', '产品方案', '...'],
      btns1: ['在线点餐', '快捷下单', '在线支付', '用户评价', '在线充值', '智能统计', '线下取餐', '...'],
      btns2: ['学习任务', '我的课程', '智能排课', '资源中心', '我的考试', '积分管理', '证书管理', '讲师管理', '...'],
      btns3: ['门户模板', '浮动图片', '导航树', '快捷方式', 'APP唤醒', '...'],
      btns4: ['发文拟稿', '移动手签', '公文套红', '电子签章', '公文分发', '收文登记', '收文分发', '智能统计', '...'],
      btns5: ['组织管理', '党员管理', '信息管理', '数据管理', '系统管理', '组织活动', '党务工作', '纪检工作', '...'],
      flag1: 1,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        slidesPerView: 1,
        loop: true,
        centeredSlides: true
      }
    }
  },
  created () {
    this.$store.commit('changeNav', 1)
  },
  methods: {
    change () {
      if (this.flag1 === 1) {
        this.flag1 = 2
      } else if (this.flag1 === 2) {
        this.flag1 = 1
      }
    },
    goWe () {
      window.scroll(0, 0)
      this.$router.push('/we')
    },
    goProduct (id) {
      window.scroll(0, 0)
      if (id === 1) {
        this.$router.push('/platform')
      } else if (id === 2) {
        this.$router.push('/canteen')
      } else if (id === 3) {
        this.$router.push('/college')
      } else if (id === 4) {
        this.$router.push('/vote')
      } else if (id === 5) {
        this.$router.push('/document')
      } else if (id === 6) {
        this.$router.push('/partybuilding')
      }
    },
    goSlution () {
      window.scroll(0, 0)
      this.$router.push('/slution')
    },
    goNews (flag2) {
      window.scroll(0, 0)
      var obj = { id: flag2 }
      this.$router.push({ path: 'newsdetails', query: obj })
    },
    goproduct () {
      window.scroll(0, 0)
      this.$router.push('/product')
    },
    goCase () {
      window.scroll(0, 0)
      this.$router.push('/case')
    }
  },
  mounted () {
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .cooperationBox,.newsBox,.solutionBox,.productBox,.weBox{
    width: 100%;
    height: 800px;
    .banner{
      width: 100%;
      img{
        width: 100%;
        vertical-align: middle;
      }
    }
    .cooperationHeader,.newsHeader,.solutionHeader,.productHeader,.weHeader{
      height: 228px;
      text-align: center;
      overflow: hidden;
      h3{
        font-size: 34px;
        margin-top: 68px;
        font-weight: 400;
        span{
          color: #007BF9;
        }
      }
      p{
        margin-top: 15px;
        font-size: 20px;
        color: #666;
      }
      em{
        display: inline-block;
        width: 19px;
        height: 2px;
        background-color: #00F6F9;
      }
    }
    .weBody{
      .bodyLeft{
        float: left;
        width: 50%;
        h3{
          font-size: 24px;
          color: #007BF9;
          font-weight: 400;
          margin: 44px 0 20px 128px;
        }
        .card{
          position: relative;
          margin-left: 128px;
          width: 484px;
          line-height: 27px;
          overflow: hidden;
          p{
            margin: 20px 0 20px 20px;
            text-align:justify;
          }
          .iconbianjiao{
            position: absolute;
            top: 10px;
            left: 0px;
            font-size: 34px;
            color: #007BF9;
          }
          .iconbianjiao-copy{
            position: absolute;
            bottom: 12px;
            right: 0px;
            font-size: 34px;
            color: #00F6F9;
          }
        }
        button{
          width: 120px;
          height: 40px;
          font-size: 14px;
          color: #3D3D3D;
          border: 1px solid #007BF9;
          background-color: #fff;
          margin: 100px 0 0 128px;
        }
      }
      .bodyRight{
        position: relative;
        float: left;
        width: 40%;
        img{
          width: 100%;
        }
        // .broadcast{
        //   position: absolute;
        //   bottom: 5px;
        //   left: -120px;
        //   width: 240px;
        //   height: 118px;
        //   background-color: #0072E6;
        //   color: #fff;
        //   text-align: center;
        //   padding-top: 32px;
        //   cursor: pointer;
        //   .iconbofanganniu{
        //     font-size: 48px;
        //   }
        //   p{
        //     margin-top: 10px;
        //     font-size: 14px;
        //   }
        // }
      }
    }
  }
  .productBox{
    height: 904px;
    overflow: hidden;
    .productHeader{
      background-image: url(../assets/img/bc1.png);
      background-size: 100%;
    }
    .productBody{
      height: 683px;
      background-image: url(../assets/img/bc4.jpg);
      background-size: 100%;
      .goodsBox{
        width: 70%;
        height: 100%;
        margin: 0 auto;
        .goodsTitle{
          height: 120px;
          ul{
            height: 100%;
            li{
              position: relative;
              float: left;
              width: 16.6%;
              height: 93px;
              text-align: center;
              color: #fff;
              padding-top: 27px;
              cursor: pointer;
            }
            li:nth-child(even){
              background-color: #0057B0;
            }
            li:nth-child(odd){
              background-color: #0072E6;
            }
            .green{
              background-color: #00D1D4!important;
            }
            .green::before{
              content: "";
              position: absolute;
              bottom: -8px;
              left: 50%;
              width: 18px;
              height: 18px;
              transform: translateX(-50%) rotate(45deg);
              background-color: #00D1D4;
            }
            .iconfont{
              font-size: 30px;
            }
            p{
              font-size: 18px;
              margin-top: 16px;
            }
          }
        }
        .goodsBody{
          height: 563px;
          width: 100%;
          background-image: url(../assets/img/bc2.jpg);
          background-size: 100%;
          .oneBox{
            padding: 59px 0 0 80px;
            color: #fff;
            .oneTitle{
              font-size: 24px;
              padding-bottom: 30px;
            }
            p{
              width: 72%;
              line-height: 30px;
              padding-bottom: 70px;
              text-align:justify;
            }
            .btns{
              height: 200px;
              ul{
                width: 80%;
                height: 100%;
                li{
                  float: left;
                  width: 12%;
                  height: 42px;
                  line-height: 42px;
                  text-align: center;
                  border: 1px solid #fff;
                  margin:0 29px 41px 0;
                }
                li:hover{
                  background-color: #007BF9;
                  cursor: default;
                }
              }
            }
            a{
              color: #fff;
            }
          }
        }
      }
    }
  }
  .solutionBox{
    .solutionBody{
      height: 500px;
      padding-bottom: 80px;
      ul{
        width: 70%;
        height: 100%;
        margin: 0 auto;
        li{
          float: left;
          width: 30%;
          height: 500px;
          text-align: center;
          color: #fff;
          .one{
            width: 100%;
            height: 100%;
            h3{
              font-size: 20px;
              padding: 150px 0 16px;
              font-weight: 400;
            }
            em{
              display: inline-block;
              width: 26px;
              height: 2px;
              background-color: #fff;
              margin: 25px 0;
            }
            .iconicon-right{
              font-size: 30px;
            }
            p:nth-child(4){
              margin-bottom: 40px;
            }
          }
          .one:hover{
            background-color: rgba(0, 123, 249, .5);
          }
        }
        li:nth-child(1){
          background-image: url(../assets/img/nav1.jpg);
          background-size: cover;
        }
        li:nth-child(2){
          margin: 0 46px;
          background: url(../assets/img/nav4.jpg) -222px -2px;
          background-size: cover;
        }
        li:nth-child(3){
          background: url(../assets/img/nav6.jpg) -170px -24px;
          background-size: cover;
        }
      }
    }
  }
  .newsBox{
    background-color: #F9F9F9;
    height: 700px;
    .newsBody{
      width: 70%;
      margin: 0 auto;
      .btnBox{
        text-align: center;
        margin-bottom: 59px;
        button{
          width: 168px;
          height: 57px;
          border-radius: 28px;
          border: 1px solid #007BF9;
          color: #727272;
        }
        .blue{
          background-color: #007BF9;
          color: #fff;
        }
        button:nth-child(1){
          margin-right: 35px;
        }
      }
      ul{
        li{
          float: left;
          width: 30%;
          background-color: #fff;
          padding-bottom: 15px;
          color: #363636;
          img{
            width: 100%;
            height: 266px;
          }
          p{
            padding: 15px 15px 0;
            height: 57px;
          }
          .date{
            margin-top: 15px;
            padding-left: 15px;
            span{
              font-size: 14px;
            }
            span:nth-child(2){
              padding-left: 154px;
              color: #007BF9;
            }
          }
        }
        li:hover{
          color: #007BF9;
        }
        li:nth-child(2){
          margin: 0 46px;
        }
      }
    }
  }
  .cooperationBox{
    height: 400px;
    .cooperationBody{
      height: 172px;
      width: 70%;
      margin: 0 auto;
      .tags{
        padding-left: 4px;
        ul{
          li{
            float: left;
            width: 19%;
            height: 85px;
            border: 1px solid #DFDFDF;
            margin-right: 9px;
            img{
              display: inline-block;
            }
          }
          li:nth-child(5){
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
